import { AppState, AppStateActionParams } from 'records/AppState';
import { GeoLocation } from 'records/GeoLocation';

export interface GeoLocationActions {
  setProjectGeoLocation: (
    actionParams: AppStateActionParams,
    newGeoLocation: GeoLocation
  ) => Promise<AppState>;
}

const geoLocationActions: GeoLocationActions = {
  setProjectGeoLocation: async (
    { state }: AppStateActionParams,
    newGeoLocation
  ): Promise<AppState> => {
    return state().setIn(['geoLocation'], newGeoLocation);
  },
};

export default geoLocationActions;
